import { addCLinkerToUrl } from './cLinkerUtils';

const removeUtmParameters = (url = '') => {
    try {
        const urlObject = new URL(url);
        const searchParams = new URLSearchParams(urlObject.search);

        // Collect all utm_ parameter keys first to avoid iterator issues
        const utmKeys = Array.from(searchParams.keys()).filter((key) => key.startsWith('utm_'));

        // Remove all utm_ parameters
        utmKeys.forEach((key) => searchParams.delete(key));

        urlObject.search = searchParams.toString();
        return urlObject.toString();
    } catch (error) {
        // If URL parsing fails, return original URL
        return url;
    }
};

const getTransformedEcommLink = (
    href = '',
    label = 'Continue Online',
    existingDealXgId,
    dealerWebsiteConfig = {},
    baseUrl = '',
    dealerId,
    shouldRemoveUtmParams = false,
    chatSessionId = null
) => {
    if (!href) {
        return href;
    }

    const dealerIdKey = 'dealerId';

    const params = {
        ...dealerWebsiteConfig,
        utm_content: `${label.replace(/\s/g, '_').toLowerCase()}_button`,
        dealXGID: existingDealXgId,
        dealerId,
    };

    if (baseUrl) {
        params.url = encodeURI(baseUrl);
    }

    // Add chat session ID if available
    if (chatSessionId) {
        params.chatSessionId = chatSessionId;
    }

    // Use the URL API, but fail gracefully if URL is malformed
    let url;
    try {
        url = new URL(href);
        url.searchParams.delete('utm_content'); // deleting utm_content param to make sure right label is passed.
        url.searchParams.delete('dealXGID'); // deleting dealXGID param to make sure right value is passed.
    } catch {
        return href;
    }

    // Config features may contain duplicate keys (snake_case and camelCase)
    // So explicitly defining parameters we want to support for href manipulation
    // in a single place
    const supportedParams = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'dealXGID',
        'url',
        'chatSessionId',
    ];

    // Temporarily removes ATC-added parameters
    // for backward compatibility
    if (
        ['autotrader.com', 'kbb.com'].includes(url.searchParams.get('utm_source')) &&
        ['autotrader_listings', 'kbb_listings'].includes(url.searchParams.get('utm_campaign'))
    ) {
        url.searchParams.delete('utm_source');
        url.searchParams.delete('utm_campaign');
        url.searchParams.delete('utm_medium');
    }
    // End temp code

    // Set parameters and values
    supportedParams.forEach(
        (param) => params[param] && !url.searchParams.has(param) && url.searchParams.append(param, params[param])
    );

    if (dealerId && !url.searchParams.has(dealerIdKey)) url.searchParams.append(dealerIdKey, dealerId);

    const finalUrl = shouldRemoveUtmParams ? removeUtmParameters(url.toString()) : url.toString();

    // Add CLinker for cross-domain tracking
    return addCLinkerToUrl(finalUrl);
};

export default getTransformedEcommLink;
